export default __webpack_public_path__ + "static/intro_splash-720w-14a9333d5d6e35a23f1bc3bb8d875a8f.mp4";